import React, { useState, useEffect }  from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import { TitleBar, IconCircle, IconClose, IconCheck, evenRowColor } from '../common/theme';
import { isObjectEmpty } from '../../Utils';

const ProgramAssignmentTableComp = ({pageState}) => {    

    const titleRow = <TitleBar>
        <Col  style={{textAlign: 'left'}} xs='6'>Programs</Col>
        <Col xs='2'>Pre-Test</Col>
        <Col xs='2'>Post-Test</Col>
        <Col xs='2'>Assigned Modules</Col>
    </TitleBar>;

    const userTitleRow = <TitleBar>
        <Col  style={{textAlign: 'left'}} xs='4'>Programs</Col>
        <Col xs='6'>Description</Col>
        <Col xs='2'>Assigned Modules</Col>
    </TitleBar>;
    const [isAdminChecked,setIsAdminChecked] = useState(false);
    const [isUserCateg,setIsUserCateg] = useState(false);
    const [hasUserTeachAdminLessons,sethasUserTeachAdminLessons] = useState(false);
    //const [hasUserAdminLessons,sethasUserAdminLessons] = useState(false);

    useEffect(() => {
        const checkIfUserTable=()=>{
            if(pageState.processedProgramAssignments.length > 0){
                if(pageState.processedProgramAssignments[0].categ == 'User')
                    return true;
            }
            return false;
        };

        const checkIfHasAdminLessons=()=>(pageState.processedProgramAssignments.filter(item=>(item.schoolID === item.authorID)).length>0);                
        const checkIfHasTeacherLessons=()=>(pageState.processedProgramAssignments.filter(item=>(item.schoolID !== item.authorID)).length>0);        
        sethasUserTeachAdminLessons(checkIfUserTable() && checkIfHasAdminLessons() && checkIfHasTeacherLessons());
        // sethasUserAdminLessons(checkIfUserTable() && checkIfHasAdminLessons());
        setIsUserCateg(checkIfUserTable());
    });    

    const onChangeHandler=(event)=>{
        setIsAdminChecked(event.target.checked);
    };

    const filterAdmin=(item)=>{
        if(pageState.isAdmin && isAdminChecked) return (item.schoolID === item.authorID);
        if(!pageState.isAdmin && isAdminChecked) return (item.schoolID !== item.authorID);
        return true;
    };

    return ( 
        <Container>           
            {isUserCateg && <>
                {hasUserTeachAdminLessons && <><input type="checkbox" onChange={(e)=>onChangeHandler(e)} checked={isAdminChecked}/> {pageState.isAdmin ? <>Hide Teacher Lists</> :<> Hide Shared Lists</>} </>}
                {userTitleRow} 
                {pageState.processedProgramAssignments.filter(item=>filterAdmin(item)).map((programRec, i) => 
                    <ProgramRowUser key={i} index={i} programRec={programRec} componentState={{checkboxState:pageState.checkboxState, setCheckboxState:pageState.setCheckboxState}} pageState={pageState}/>
                )}                       
            </>}
            {!isUserCateg && <>    
                {titleRow}        
                {pageState.processedProgramAssignments.filter(item=>filterAdmin(item)).map((programRec, i) => 
                    <ProgramRow key={i} index={i} programRec={programRec} componentState={{checkboxState:pageState.checkboxState, setCheckboxState:pageState.setCheckboxState}} pageState={pageState}/>
                )}
            </>}
        </Container>
    ); 
};

ProgramAssignmentTableComp.propTypes = {
    data: PropTypes.object
};

const CombinedIcon = ({type}) => <>
   {type === 'Mixed' && <IconCircle style={{color: 'green', fontSize: '10px' }}/>}
   {type === 'None' && <IconClose style={{color: '#EfEfEf'}} />}
    {type === 'All' && <IconCheck style={{color: 'green'}}/>}
</>;

const ProgramRow = ({pageState, programRec, index}) => {
    let {id, title} = programRec;    

    const selectedStyle = () =>{
        let style = {cursor: 'pointer',color:'blue',textDecoration:'none' };
        style['background'] = (index%2==0)?evenRowColor:'FFFFFF';
        return style;
    };

    const showModules = (programID) =>{
        pageState.setShowModulesComp(programID);
    };
    
    // const WordList=()=>{
    //     if(programRec.Description){
    //         return <>
    //             <div style={{ color:'black', paddingBottom:'20px' }}>({programRec.Description})</div>
    //         </>;
    //     }
    //     return <></>;            
    // };

    return (
        <>
        <Row onClick={() => showModules(id)} style={selectedStyle()}> 
            {/* <Col xs='6'> <span style={{textDecoration: 'underline'}}> {title} </span> <WordList></WordList>  </Col> */}
            <Col xs='6'> <span style={{textDecoration: 'underline'}}> {title} </span> </Col>
            <Col style={{textAlign: 'center'}} xs='2'> <CombinedIcon type={programRec.hasPretest}/> </Col>
            <Col style={{textAlign: 'center'}} xs='2'> <CombinedIcon type={programRec.hasPosttest}/> </Col>
            <Col style={{textAlign: 'center'}} xs='2'> <CombinedIcon type={programRec.hasAssignment}/></Col>
        </Row>
        </>
    );
};

const ProgramRowUser = ({pageState, programRec, index}) => {
    let {id, title} = programRec;    

    const selectedStyle = () =>{
        let style = {cursor: 'pointer',color:'blue',textDecoration:'none' };
        style['background'] = (index%2==0)?evenRowColor:'FFFFFF';
        return style;
    };

    const showModules = (programID) =>{
        pageState.setShowModulesComp(programID);
    };
    
    return (
        <>
        <Row onClick={() => showModules(id)} style={selectedStyle()}> 
            <Col xs='4'> <span style={{textDecoration: 'underline'}}> {title} </span>  </Col>
            <Col style={{textAlign: 'center'}} xs='6'> <div style={{ color:'black' }}>{programRec.Description}</div> </Col>
            <Col style={{textAlign: 'center'}} xs='2'> <CombinedIcon type={programRec.hasAssignment}/></Col>
        </Row>
        </>
    );
};

export default ProgramAssignmentTableComp;